/* eslint-disable */
import React from 'react';
import { fade } from '@material-ui/core';

const AllergiEndResourcesLogo = ({ fill, className }) => (
  <svg className={className}  xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960'
       fill={fill || "#FFFFFF"}>
    <path
      d='M453.85-293.85h292.3v-14.3q0-40-39.57-62.85Q667-393.85 600-393.85T493.42-371q-39.57 22.85-39.57 62.85v14.3ZM600-446.15q29.15 0 49.58-20.43Q670-487 670-516.15q0-29.16-20.42-49.58-20.43-20.42-49.58-20.42t-49.58 20.42Q530-545.31 530-516.15q0 29.15 20.42 49.57 20.43 20.43 49.58 20.43ZM172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h219.61l80 80h315.77Q818-700 839-679q21 21 21 51.31v375.38Q860-222 839-201q-21 21-51.31 21H172.31Zm0-60h615.38q5.39 0 8.85-3.46t3.46-8.85v-375.38q0-5.39-3.46-8.85t-8.85-3.46H447.38l-80-80H172.31q-5.39 0-8.85 3.46t-3.46 8.85v455.38q0 5.39 3.46 8.85t8.85 3.46ZM160-240v-480 480Z' />
  </svg>
);

export default AllergiEndResourcesLogo;
